import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Link as ScrollLink } from 'react-scroll';
import ThemeToggle from './ThemeToggle';

export default function Header() {
  const [mobileToggle, setMobileToggle] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      const scrollY = window.scrollY;
      if (scrollY > 50) {
        setScrolled(true);
      } else {
        setScrolled(false);
      }
    };
    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  const NavItem = ({ to, title }) => {
    if (location.pathname === '/') {
      return (
        <li>
          <ScrollLink
            to={to}
            spy={true}
            smooth={true}
            offset={-100}
            duration={500}
            activeClass="active"
            onClick={() => setMobileToggle(false)}
            style={{ cursor: 'pointer' }}
          >
            {title}
          </ScrollLink>
        </li>
      );
    }
    return (
      <li>
        <Link to={`/`} onClick={() => setMobileToggle(false)}>
          {title}
        </Link>
      </li>
    );
  };

  return (
    <div
      className={`header-top-fixed one-page-nav ${mobileToggle ? 'menu-open menu-open-desk' : ''
        } ${scrolled ? 'fixed-header' : ''}`}
    >
      <div className="container-fluid px-4 px-lg-5">
        <div className="logo">
          <Link className="navbar-brand" to="/">
            <img
              className="logo-light"
              title="Kunal Das Logo"
              alt="Kunal Das Portfolio Logo"
              src="/images/tag.png"
            />
          </Link>
        </div>
        {/* / */}
        <ul className="main-menu">
          <NavItem to="home" title="Home" />
          <NavItem to="about" title="About Me" />
          <NavItem to="project" title="My Work" />
          <NavItem to="services" title="Abilities & Skills" />
          <NavItem to="devprojects" title="Projects" />
        </ul>
        {/* Top Menu */}
        <div className="d-flex align-items-center">
          <ThemeToggle />

          {location.pathname === '/' ? (
            <ScrollLink
              to="contactus"
              spy={true}
              smooth={true}
              offset={-100}
              duration={500}
              onClick={() => setMobileToggle(false)}
              className="px-btn d-none d-lg-inline-flex"
              style={{ cursor: 'pointer' }}
            >
              Let's Talk
            </ScrollLink>
          ) : (
            <Link
              to="/"
              onClick={() => setMobileToggle(false)}
              className="px-btn d-none d-lg-inline-flex"
            >
              Let's Talk
            </Link>
          )}

          <Link to="/blog" className="px-btn d-none d-lg-inline-flex ms-3">
            Read my blogs
          </Link>
          <button
            className="toggler-menu d-lg-none"
            onClick={() => setMobileToggle(!mobileToggle)}
          >
            <span />
          </button>
        </div>
        {/* / */}
      </div>
    </div>
  );
}
